/**
 * Accordion
 *
 * Adds a simple accordion
 */

(function Accordion() {
    const elements = $('.accordion');
    const classes = {
        active: 'is-active'
    };

    /**
     * Create
     */
    function create() {
        $.each(elements, function(index, element) {
            var accordion = $(element);

            initializeAccordion(accordion);

            if (accordion.next('.accordion').length == 0) {
                accordion.addClass('is-last');
            }
        });
    }

    function initializeAccordion(accordionElement) {
        accordionElement.find('.accordion__trigger').on('click', function() {
            toggleAccordion($(this));
        });
    }

    function toggleAccordion(accordionTrigger) {
        accordionTrigger.toggleClass(classes.active);
        accordionTrigger.next('.accordion__content').toggleClass(classes.active);
    }

    if (elements.length > 0) {
        create();
    }
})();